// extracted by mini-css-extract-plugin
export default {"checkmarkBoxContainer":"FormLocationPref_checkmarkBoxContainer__YjwB+","pref":"FormLocationPref_pref__+LbfH"};